var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.46484,
    y: 25.5078,
    width: 11.3571,
    height: 10.4107,
    fill: "#FF8165"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2105 1.84375H26.2738C27.3221 1.84375 28.1797 2.54062 28.1797 3.39238V8.81287C28.1797 9.66474 27.3221 10.3616 26.2738 10.3616H10.2105C9.16237 10.3616 8.30469 9.66474 8.30469 8.81287V3.39238C8.30469 2.54062 9.16237 1.84375 10.2105 1.84375Z",
    fill: "#A020FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3939 2.03906H25.8874C26.8985 2.03906 27.7256 2.87904 27.7256 3.90572V10.4393C27.7256 11.4661 26.8985 12.3061 25.8874 12.3061H10.3939C9.38292 12.3061 8.55566 11.4661 8.55566 10.4393V3.90572C8.55566 2.87904 9.38292 2.03906 10.3939 2.03906Z",
    stroke: "#081E54",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4707 13.4453V14.3895C25.4707 17.9071 31.1089 18.0689 31.1089 21.0794V25.4019",
    stroke: "#081E54",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9396 44.2465H7.84486C6.37821 44.2465 5.17285 43.0029 5.17285 41.4822V21.5943C5.17285 18.3732 10.2994 18.2103 10.2994 14.453V13.4453",
    stroke: "#081E54",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17285 23.7109H16.7834V36.2596H5.17285V23.7109Z",
    stroke: "#081E54",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9833 21.3747C25.1798 20.8744 26.4962 21.416 27.0055 22.535L29.6033 28.2415C29.8397 27.6841 30.2955 27.2071 30.9086 26.9506L30.9092 26.9504C31.9994 26.4949 33.2246 26.8876 33.7862 27.8225C33.969 27.1361 34.473 26.5273 35.1962 26.2247H35.197C36.2869 25.7696 37.512 26.1622 38.0738 27.0968C38.2566 26.4104 38.7606 25.8015 39.4843 25.4991C40.6807 24.9993 42.1048 25.4969 42.5064 26.6597L45.4607 35.216C47.8626 42.1732 39.2878 49.5098 32.8639 45.3043L21.7209 38.0104C20.6784 37.3284 20.4392 35.9198 21.1888 34.8801C22.3752 34.3848 24.7217 34.4113 25.7713 35.0986L27.8816 36.48L22.6557 24.3529C22.1694 23.2236 22.7872 21.8748 23.9833 21.3747Z",
    stroke: "#081E54",
    strokeWidth: 1.33929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon7);
export default __webpack_public_path__ + "static/media/icon-7.5d5f915343af44e67182626c667abad9.svg";
export { ForwardRef as ReactComponent };